


























































































































































































import {
  Vue,
  Prop,
  Watch,
  Component,
} from "@/shared/vuepack";
import { MobileApp, UserPermission } from "@/shared/types";
import * as _ from "lodash";
import { Validator } from "vee-validate";
import * as RouteNames from "@/admin/route-names";
import { useNotifierStore } from "@/shared/store/notifier";
import { useMobileAppStore } from "@/shared/store/mobileApp";
import { usePartnerStore } from "@/admin/store/partner";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({})
export default class ManageMobileApp extends Vue {
  notifierStore = useNotifierStore();
  partnerStore = usePartnerStore();
  mobileAppStore = useMobileAppStore();
  rolePermissionsStore = useRolePermissionsStore();
  featureFlagStore = useFeatureFlagStore();

  $validator: Validator;
  isMobileAppLoaded = false;
  updateFormInSubmit = false;

  model: MobileApp = {
    mobileAppId: 0,
    appIdentifier: "",
    name: "",
    description: "",
    dateCreated: "",
    dateModified: "",
    partnerId: 0,
    partnerName: "",
    allowedPartners: [],
    minSuggestedVersion: "",
    minRequiredVersion: "",
    googlePlayStoreUrl: "",
    appleStoreUrl: ""
  };

  @Prop() appId: number;

  @Watch("mobileAppStore.mobileApps",  { deep: true })
  onMobileAppIdIdChanged () {
    if (!this.mobileAppStore.mobileApps && !this.mobileAppStore.mobileApps.length) {
      return;
    }

    if (!this.appId) {
      return;
    }

    const mobileApp: MobileApp = this.mobileAppStore.mobileAppById(this.appId);

    if (!mobileApp) {
      return;
    }

    this.model = {...mobileApp};
  }

  get allowedPartners () {
    const options = [];
    if (!this.partnerStore.allPartners) {
      return options;
    }

    return this.partnerStore.allPartners.map(partner => ({
      text: partner.name,
      value: partner.id
    }));
  }

  get selectedAllowedPartners () {
    if (!this.model || !this.model.allowedPartners) {
      return [];
    }

    return this.model.allowedPartners
        .map(p => p.partnerId);
  }

  selectedAllowedPartnersUnsaved: number[] = [];
  @Watch("selectedAllowedPartners")
  watchOfSelectedAllowedPartners (newValue) {
    this.selectedAllowedPartnersUnsaved = newValue;
  }

  doUpdateMobileApp () {
    const newAllowedPartners = this.partnerStore.allPartners.filter(partner =>
        _.some(this.selectedAllowedPartnersUnsaved, partnerId => partnerId === partner.id));

    this.model.allowedPartners  = newAllowedPartners.map((p: any) => ({
      partnerId: p.id,
      partnerName: p.companyName
    }));

    this.mobileAppStore.updateMobileApp(this.model)
        .then(() => {
          this.updateFormInSubmit = false;
        })
        .catch(() => {
          this.updateFormInSubmit = false;
        });
  }

  onSubmitChanges (e: Event) {
    e.preventDefault();
    this.$validator.validateAll()
        .then(isValid => {
          if (this.updateFormInSubmit || !isValid) {
            return;
          }
          this.updateFormInSubmit = true;
          this.doUpdateMobileApp();
        });
  }

  routeToMobileAppList () {
    return { name: RouteNames.MobileAppList, params: { page: this.mobileAppStore.pageNumber } };
  }

  mounted (): void {
    this.isMobileAppLoaded = false;
    this.partnerStore.reload();
    this.onMobileAppIdIdChanged();
    this.isMobileAppLoaded = true;
  }

  get hasEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityMobileAppsEdit);
  }
}
